import {createReducer} from 'redux-create-reducer';
import {Keys, Actions} from '../constants';
import {standardLoadingReducerFactory} from './reducer-utils';

export default createReducer(
    {},
    Object.assign(
        {},
        standardLoadingReducerFactory(
            Actions.GET_CURRENT_WORK_SESSION,
            Keys.StoreSliceData.CURRENT_WORK_SESSION,
        ),
        standardLoadingReducerFactory(
            Actions.CREATE_NEW_WORK_SESSION,
            Keys.StoreSliceData.CURRENT_WORK_SESSION,
        ),
        standardLoadingReducerFactory(
            Actions.PATCH_WORK_SESSION,
            Keys.StoreSliceData.CURRENT_WORK_SESSION,
        )
    )
);



// WEBPACK FOOTER //
// ./src/model/reducers/current-work-session-reducer.js